import React, { useContext, useEffect, useState } from "react";
import {
  View,
  Text,
  Switch,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
  PixelRatio,
  Dimensions,
  Platform,
  ActivityIndicator,
  Modal,
} from "react-native";
import { Image } from "expo-image";
import { MaterialCommunityIcons, Ionicons } from "@expo/vector-icons";
import Colours from "../../utils/Colours";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import { useNavigation, useRoute } from "@react-navigation/native";
import AppContext from "../../context/AppContext";
import { useWebSafeArea } from "../../hooks/useWebHeights";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import { SafeAreaView } from "react-native-safe-area-context";
import DoingsModeBadge from "../../icons/DoingsModeBadge";

const { width, height } = Dimensions.get("window");

// --- RESPONSIVE TOOLKIT ---
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  return Math.round(PixelRatio.roundToNearestPixel(size * scaleFactor));
};
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const ChooseYourFlexSpend = () => {
  const webSafeArea = useWebSafeArea();

  // Extracting location context from router parameters
  const navigation = useNavigation();
  // const axiosPrivate = useAxiosPrivate();
  const route = useRoute();
  // const { tableId } = route.params || {};
  const { tableId: paramTableId, isTopUp: paramIsTopUp } = route.params || {};
  // 2. Fall back to sessionStorage if a reload wiped the navigation memory
  const isTopUp = paramIsTopUp || sessionStorage.getItem("is_topup_flow") === "true";

  // Optional: Do the same for tableId if you saved it earlier, to keep reloads from breaking the page
  const tableId = paramTableId || sessionStorage.getItem("active_checkout_table_id");
  const { sub } = useAuth();

  // 2. State trackers for database fetching and local selections
  const [table, setTable] = useState(null);
  const [selectedFlex, setSelectedFlex] = useState("doings");
  const [isLoading, setIsLoading] = useState(true);
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);

  // 3. Hydrate screen from database on component mount
  useEffect(() => {
    const fetchTableContext = async () => {
      if (!tableId) return;
      try {
        setIsLoading(true);
        // Replace this string placeholder with your actual axios API client instance
        const response = await axios.get(`/tableDetailsPublic/tableDetailsPublic/${tableId}`);

        //console.log("response.Datahh", response.data.tableData);
        const tableData = response.data.tableData;

        if (response.data) {
          setTable(tableData);
          // setSelectedFlex(tableData.flexTier || "doings");
          // Inside your useEffect hook change this line:
          setSelectedFlex(tableData.flexTier === "regular" ? "regular" : "doings");
        }
      } catch (error) {
        console.error("Failed fetching table context data for flex setup:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTableContext();
  }, [tableId]);

  // 4. Fire navigation forward passing parameters cleanly down the URL tree
  const handleNextStep = () => {
    if (!tableId) return;

    console.log("selectedFlexxxxx", selectedFlex);

    navigation.navigate("brandMenu", {
      tableId: tableId,
      flexTier: selectedFlex, // Forward "regular" or "doings" straight into the PWA URL
      tableAnonymity: isAnonymous,
      isTopUp: isTopUp,
    });
  };

  // 5. Render Loading Spinner during background asset population
  if (isLoading) {
    return (
      <View
        style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "#fff" }}
      >
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  const brandName = table?.associatedBrand?.brandName || "the venue";
  const brandAddress = table?.associatedBrand?.brandAddress || "location not set yet";
  const brandImage = table?.associatedBrand?.image || "https://placehold.co/150";

  const handleBackNavigation = () => {
    const routes = navigation.getState()?.routeNames || [];
    const targetRoute = routes.includes("Home") ? "Home" : "main";

    if (sub) {
      console.log("here");
      navigation.navigate(targetRoute);
    } else {
      setErrorMessage("Please scan the QR code again from the waiter if you are lost ");
      setIsErrorCompVisible(true);
    }
  };

  return (
    <SafeAreaView style={[styles.safeArea, webSafeArea]}>
      <TopHeaderComponent
        headerText={"Choose Your Spend Mode"}
        hideScreen={() => handleBackNavigation()}
      />
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={styles.scrollWrapper}
        showsVerticalScrollIndicator={false}
      >
        {/* REUSED BRAND HERO CARD */}
        <View style={styles.brandHeroCard}>
          <Image
            source={{ uri: brandImage || "https://placehold.co/150" }}
            style={styles.brandImage}
            contentFit="cover"
            cachePolicy="disk"
          />
          <View style={styles.brandMetaInfo}>
            <Text style={styles.nameTxt} numberOfLines={1}>
              {brandName || "Company Title"}
            </Text>
            <Text style={styles.emailTxt} numberOfLines={2}>
              {brandAddress || "Location Details Not Set"}
            </Text>
          </View>
        </View>

        {/* <Text style={styles.sectionLabel}>CHOOSE YOUR BILLING & VISIBILITY FLEX</Text> */}
        <Text style={styles.sectionLabel}>CHOOSE YOUR BILLING MODE</Text>

        {/* OPTION 2: DOINGS SPEND FLEX (STANDOUT premium DESIGN) */}
        <TouchableOpacity
          activeOpacity={0.85}
          onPress={() => setSelectedFlex("doings")}
          style={[
            styles.flexCard,
            styles.doingsCardBase,
            selectedFlex === "doings" && styles.activeDoingsCard,
          ]}
        >
          {/* Top Premium Tag Banner */}
          <View style={styles.premiumRibbon}>
            <MaterialCommunityIcons name="crown" size={dynamicSize(12)} color="white" />
            <Text style={styles.premiumRibbonText}>HIGH VISIBILITY MODE</Text>
          </View>

          <View style={styles.flexCardHeader}>
            <View style={{ flexDirection: "row", alignItems: "center", gap: dynamicSpacing(10) }}>
              <View style={[styles.iconBadge, { backgroundColor: "#FFF4E5" }]}>
                <MaterialCommunityIcons name="fire" size={dynamicSize(24)} color="#FF9900" />
              </View>
              <View>
                {/* <Text style={[styles.flexTitle, { color: "#1A1A1A" }]}>Doings spend flex</Text> */}
                <Text style={[styles.flexTitle, { color: "#1A1A1A" }]}>Doings Mode</Text>
                <Text style={[styles.flexSubTitle, { color: "#E67E00" }]}>
                  Luxury & Maximum Visibility Mode
                </Text>
              </View>
            </View>
            <Ionicons
              name={selectedFlex === "doings" ? "checkmark-circle" : "ellipse-outline"}
              size={dynamicSize(24)}
              color={selectedFlex === "doings" ? "#FF9900" : "#DDD"}
            />
          </View>

          {/* STANDOUT HIGHLIGHT PERK LIST */}
          <View style={styles.perksContainer}>
            <View style={styles.perkRow}>
              <Ionicons
                name="flash"
                size={dynamicSize(15)}
                color="#FF9900"
                style={styles.perkIcon}
              />
              <Text style={styles.perkText}>
                Your table shows up top on the Doings Trend. Think of Doings Trend as Twitter Trends
                but for tables.It gives your table visibility in{" "}
                <Text style={{ fontFamily: "Sen-Bold" }}>{brandName}</Text> and across meeza social
                platform.
              </Text>
            </View>

            {/* <View style={styles.perkRow}>
              <Ionicons name="eye" size={dynamicSize(15)} color="#FF9900" style={styles.perkIcon} />
              <Text style={styles.perkText}>
                Gain visibility at <Text style={{ fontFamily: "Sen-Bold" }}>{brandName}</Text> and
                across the Meeza platform — just for hanging out.
              </Text>
            </View> */}

            <View style={styles.perkRow}>
              {/* <MaterialCommunityIcons
                name="incognito"
                size={dynamicSize(16)}
                color="#FF9900"
                style={styles.perkIcon}
              /> */}
              <View style={styles.perkIcon}>
                <DoingsModeBadge size={dynamicSize(15)} color="#D4AF37" />
              </View>
              <Text style={styles.perkText}>
                Get the Doings Badge and Make your table unique and standout among the crowd.
              </Text>
            </View>

            {/* <View style={[styles.perkRow, styles.feeHighlightRow]}>
              <Ionicons
                name="information-circle"
                size={dynamicSize(16)}
                color="#D48300"
                style={styles.perkIcon}
              />
              <Text style={[styles.perkText, { color: "#A66600", fontFamily: "Sen-Bold" }]}>
                10% Fee, Capped at ₦60,000 - the fee reflects in menu prices in the next screen.
              </Text>
            </View> */}
          </View>
        </TouchableOpacity>

        {/* ── CONDITIONAL ANONYMOUS OPTION ROW ── */}
        {/* {selectedFlex === "doings" && ( */}
        <TouchableOpacity
          style={styles.toggleRow}
          activeOpacity={0.7}
          onPress={() => setIsAnonymous(!isAnonymous)}
        >
          <View style={styles.toggleTextContent}>
            <Text style={styles.toggleTitle}>Stay Anonymous</Text>
            <Text style={styles.toggleSubTitle}>Hide your name from other guests</Text>
          </View>
          <Switch
            trackColor={{ false: "#767577", true: Colours.PRIMARY }}
            thumbColor={isAnonymous ? "#fff" : "#f4f3f4"}
            onValueChange={() => setIsAnonymous(!isAnonymous)}
            value={isAnonymous}
          />
        </TouchableOpacity>
        {/* )} */}

        {/* OPTION 1: REGULAR SPEND FLEX */}
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() => {
            setSelectedFlex("regular");
            setIsAnonymous(false);
          }}
          style={[styles.flexCard2, selectedFlex === "regular" && styles.activeRegularCard]}
        >
          <View style={styles.flexCardHeader}>
            <View style={{ flexDirection: "row", alignItems: "center", gap: dynamicSpacing(10) }}>
              <View style={[styles.iconBadge, { backgroundColor: "#F0F0F5" }]}>
                <MaterialCommunityIcons name="wallet-outline" size={dynamicSize(22)} color="#666" />
              </View>
              <View>
                {/* <Text style={styles.flexTitle}>Regular spend flex</Text> */}
                <Text style={styles.flexTitle}>Regular Mode</Text>
                <Text style={styles.flexSubTitle}>Standard order billing matrix</Text>
              </View>
            </View>
            <Ionicons
              name={selectedFlex === "regular" ? "checkmark-circle" : "ellipse-outline"}
              size={dynamicSize(24)}
              color={selectedFlex === "regular" ? Colours.PRIMARY : "#CCC"}
            />
          </View>
          {/* <Text style={styles.regularBodyText}>
            Standard table bill — pay exactly what you ordered. Menu prices remain unadjusted.
          </Text> */}
          <Text style={styles.regularBodyText}>
            Standard order spend — Minimum table visibility, just your regular order
            spend.Downgrades existing tables in doings mode down to regular mode when selected.
          </Text>
        </TouchableOpacity>
      </ScrollView>

      {/* FIXED BOTTOM SUBMIT ACTION BUTTON */}
      <View style={styles.footerStickyBar}>
        <TouchableOpacity style={styles.proceedBtn} onPress={handleNextStep}>
          <Text style={styles.proceedBtnText}>Confirm and View Menu</Text>
          <Ionicons name="arrow-forward" size={dynamicSize(18)} color="white" />
        </TouchableOpacity>
      </View>
      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </SafeAreaView>
  );
};

export default ChooseYourFlexSpend;

// --- STYLING SPEC SHEET ---
const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "#FAFAFC",
    // ...(Platform.OS === "web" && {
    //   height: "100vh",
    //   overflow: "hidden",
    // }),
  },
  scrollWrapper: {
    padding: dynamicSpacing(20),
    paddingBottom: dynamicSpacing(130),
  },

  toggleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: dynamicSpacing(12),
    borderRadius: dynamicSize(12),
    marginTop: dynamicSpacing(5),
    borderWidth: 1,
    borderColor: "#F0F0F0",
  },
  toggleTextContent: { flex: 1 },
  toggleTitle: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(14),
    color: Colours.DARKGRAY,
  },
  toggleSubTitle: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(11),
    color: "gray",
  },

  // Brand Card boilerplate compatibility setup
  brandHeroCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: dynamicSpacing(16),
    borderRadius: dynamicSize(16),
    marginBottom: dynamicSpacing(25),
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
  },
  brandImage: {
    width: dynamicSize(64),
    height: dynamicSize(64),
    borderRadius: dynamicSize(12),
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY || "#1A1A1A",
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(2),
  },
  emailTxt: {
    color: "#666",
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(16),
  },

  sectionLabel: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(11),
    color: "#888",
    letterSpacing: 1.2,
    marginBottom: dynamicSpacing(15),
  },

  // Dynamic Toggle Item Cards Shared Settings
  flexCard: {
    backgroundColor: "white",
    borderRadius: dynamicSize(16),
    padding: dynamicSpacing(16),
    marginBottom: dynamicSpacing(5),
    borderWidth: 1.5,
    borderColor: "#EAEAEF",
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.03,
    shadowRadius: 6,
  },

  flexCard2: {
    backgroundColor: "white",
    borderRadius: dynamicSize(16),
    padding: dynamicSpacing(16),
    marginTop: dynamicSpacing(20),
    marginBottom: dynamicSpacing(5),
    borderWidth: 1.5,
    borderColor: "#EAEAEF",
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.03,
    shadowRadius: 6,
  },

  flexCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: dynamicSpacing(12),
  },
  iconBadge: {
    width: dynamicSize(42),
    height: dynamicSize(42),
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    alignItems: "center",
  },
  flexTitle: {
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(16),
    color: "#333",
  },
  flexSubTitle: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(12),
    color: "gray",
    marginTop: 1,
  },
  regularBodyText: {
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(13),
    color: "#777",
    lineHeight: dynamicFontSize(18),
    paddingLeft: dynamicSpacing(2),
  },

  // Doings Standout Custom Designs Configurations
  activeRegularCard: {
    borderColor: Colours.PRIMARY,
    backgroundColor: "#FCFAFF",
  },
  doingsCardBase: {
    borderColor: "#FFE6C2",
    backgroundColor: "#FFFDFB",
    position: "relative",
    overflow: "hidden",
  },
  activeDoingsCard: {
    borderColor: "#FF9900",
    backgroundColor: "#FFFBF4",
    elevation: 4,
    shadowOpacity: 0.08,
  },
  premiumRibbon: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "#FF9900",
    paddingHorizontal: dynamicSpacing(10),
    paddingVertical: dynamicSpacing(3),
    borderBottomLeftRadius: dynamicSize(10),
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
  },
  premiumRibbonText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(9),
    letterSpacing: 0.5,
  },

  // Custom Highlight Perks Layout Wrapper
  perksContainer: {
    marginTop: dynamicSpacing(4),
    gap: dynamicSpacing(10),
  },
  perkRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  perkIcon: {
    marginRight: dynamicSpacing(8),
    marginTop: dynamicSpacing(2),
  },
  perkText: {
    flex: 1,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(13),
    color: "#4A4A4A",
    lineHeight: dynamicFontSize(19),
  },
  feeHighlightRow: {
    backgroundColor: "#FFF3DF",
    padding: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    marginTop: dynamicSpacing(4),
    borderWidth: 1,
    borderColor: "#FFE0B2",
  },

  // Bottom Safe Drawer Button
  footerStickyBar: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    paddingHorizontal: dynamicSpacing(20),
    paddingTop: dynamicSpacing(15),
    paddingBottom: Platform.OS === "ios" ? dynamicSpacing(35) : dynamicSpacing(20),
    borderTopWidth: 1,
    borderColor: "#EAEAEF",
  },
  proceedBtn: {
    backgroundColor: Colours.PRIMARY,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: dynamicSize(54),
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(10),
  },
  proceedBtnText: {
    color: "white",
    fontFamily: "Sen-Bold",
    fontSize: dynamicFontSize(16),
  },
});
